import { Toaster as Sonner, toast } from "sonner"

/**
 * Sonner toaster pinned to `theme="system"` so toasts follow the OS appearance
 * (matches our `darkMode: "media"` Tailwind config). No `next-themes`
 * ThemeProvider is mounted in this app, so reading the theme via `useTheme()`
 * would always return its default — explicit is clearer and matches the spec.
 */
const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="system"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
